var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59649 4.08325C8.88088 3.20801 10.1191 3.20801 10.4035 4.08325L11.4196 7.21046C11.5468 7.60188 11.9115 7.86689 12.3231 7.86689H15.6112C16.5315 7.86689 16.9142 9.04453 16.1696 9.58546L13.5095 11.5182C13.1765 11.7601 13.0372 12.1889 13.1644 12.5803L14.1805 15.7075C14.4648 16.5828 13.4631 17.3106 12.7186 16.7697L10.0584 14.8369C9.72543 14.595 9.27456 14.595 8.9416 14.8369L6.28144 16.7697C5.53691 17.3106 4.53515 16.5828 4.81954 15.7075L5.83563 12.5803C5.96281 12.1889 5.82348 11.7601 5.49052 11.5182L2.83036 9.58546C2.08583 9.04453 2.46847 7.86689 3.38876 7.86689H6.6769C7.08846 7.86689 7.45322 7.60188 7.5804 7.21046L8.59649 4.08325Z",
    fill: "#3EB0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.9134f6f02f52a8232b8d34cf16e21e6b.svg";
export { ForwardRef as ReactComponent };